/**
 * Utilities for safely getting, setting, and deleting values on nested objects
 * using string path arrays (e.g. ['location', 'site', 'id']).
 *
 * These are used by the form renderer, which iterates a flat list of fields
 * and needs to read/write nested values without hardcoding object traversal.
 */
export function getPathValue<T = unknown>(obj: Record<string, unknown>, path: string[]): T | undefined {
    return path.reduce<unknown>(
        (acc, key) => (acc == null ? undefined : (acc as Record<string, unknown>)[key]),
        obj,
    ) as T | undefined;
}

export function setPathValue(obj: Record<string, unknown>, path: string[], value: unknown) {
    let current = obj;
    for (let i = 0; i < path.length - 1; i += 1) {
        const key = path[i];
        if (!current[key] || typeof current[key] !== 'object') {
            current[key] = {};
        }
        current = current[key] as Record<string, unknown>;
    }
    current[path[path.length - 1]] = value;
}

export function deletePathValue(obj: Record<string, unknown>, path: string[]) {
    let current = obj;
    for (let i = 0; i < path.length - 1; i += 1) {
        const key = path[i];
        if (!current[key] || typeof current[key] !== 'object') {
            return;
        }
        current = current[key] as Record<string, unknown>;
    }
    delete current[path[path.length - 1]];
}
